import { gql } from '@apollo/client';

export const bankDetailsQuery = gql`
  query ($idFDEm: ID!) {
    getBankDetails(idFDEm: $idFDEm) {
      idFDBa
      idFDEm
      agency
      bankInstitutionId
      bankInstitutionName
      bankDataNotes
      checkingAccount
    }
  }
`;
